// AddScore.js
import React, { useState, useEffect } from "react";
import { useTournament } from "../TournamentContext";
import axios from 'axios';
import config from "../../config/default.json";
import {
  fetchGames,
  fetchTeams,
  fetchDivisions,
  saveSelectedGames,
  handleFieldChange
} from "./AdminUIhelper";

const AddScore = () => {
  const { tournamentID, tournament } = useTournament();
  const token = localStorage.getItem("token");

  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);
  const [editData, setEditData] = useState({});
  const [timeOptions, setTimeOptions] = useState([]);

  // Filters
  const [filterDivision, setFilterDivision] = useState("");
  const [filterTeam, setFilterTeam] = useState("");
  const [filterTime, setFilterTime] = useState("");

  
const base_url = config.base_url;

  const loadData = async () => {
    if (!tournamentID) return;

    const fetchedGames = await fetchGames(tournamentID);
    setGames(fetchedGames);

    setTeams(await fetchTeams(tournamentID));
    setDivisions(await fetchDivisions(tournamentID));

    // Extract unique non-empty time values for dropdown
    const uniqueTimes = [
      ...new Set(
        fetchedGames
          .map((g) => g.time)
          .filter((t) => t && t.trim() !== "")
      ),
    ].sort();
    setTimeOptions(uniqueTimes);
  };


  useEffect(() => {
    loadData();
  }, [tournamentID]);

  const onSelect = (gameId) => {
    setSelectedGames((prev) =>
      prev.includes(gameId) ? prev.filter((id) => id !== gameId) : [...prev, gameId]
    );
  };

  // const handleFieldChange = (editData,gameId, field, value) => {
  //   setEditData((prev) => ({
  //     ...prev,
  //     [gameId]: { ...prev[gameId], [field]: value },
  //   }));
  // };

  const handleSaveScores = async () => {
    await saveSelectedGames({
      tournamentID,
      token,
      selectedGames,
      editData,
      onSuccess: async () => {
        await loadData();
        setEditData({});
        setSelectedGames([]);
        alert("Scores updated successfully");
      },
    });
  };

   const CalcuateStanding = async () => {
    try {
     
      if(tournament?.isCustomStanding)
      {
        await axios.put(base_url+`/api/teamstanding/${tournamentID}`, { },  { headers: { Authorization: `Bearer ${token}` } });
      } else
      {
        alert('Please use Custom Standing! You have selected to use custom standing or change tournament setting.');
      }
      
      //setGames(updatedGames);
      alert('Standing Updated successfully!');
    } catch (error) {
      console.error('Failed to update game scores', error);
      alert('Error: '+ error.response.data.error);
    }
  };  

  // Filtered games
  const filteredGames = games.filter((game) => {
    const divisionMatch =
      !filterDivision || (game.division && game.division._id === filterDivision);
    const teamMatch =
      !filterTeam ||
      (game.team1 && game.team1._id === filterTeam) ||
      (game.team2 && game.team2._id === filterTeam);
    const timeMatch = !filterTime || game.time === filterTime;
    return divisionMatch && teamMatch && timeMatch;
  });

  return (
    <div>
      <h2>Add Scores</h2>

      {/* Filters */}
      <div style={{ marginBottom: "15px", display: "center", gap: "10px" }}>
        <select value={filterDivision} onChange={(e) => setFilterDivision(e.target.value)}>
          <option value="">All Divisions</option>
          {divisions.map((div) => (
            <option key={div._id} value={div._id}>
              {div.name}
            </option>
          ))}
        </select>
          <br />
          <br />
        <select value={filterTeam} onChange={(e) => setFilterTeam(e.target.value)}>
          <option value="">All Teams</option>
          {teams.map((team) => (
            <option key={team._id} value={team._id}>
              {team.name}
            </option>
          ))}
        </select>
          <br />
          <br />

           {/* Time filter (dynamic) */}
        <select value={filterTime} onChange={(e) => setFilterTime(e.target.value)}>
          <option value="">All Times</option>
          {timeOptions.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
          <br />
          <br />

       
      </div>

      {/* Table */}
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Select</th>
            <th>Team 1</th>
            <th>Team 2</th>
            <th>Score T1</th>
            <th>Score T2</th>
            <th>Division</th>
            <th>Court</th>
            <th>Date</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {filteredGames.map((game) => (
            <tr key={game._id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedGames.includes(game._id)}
                  onChange={() => onSelect(game._id)}
                />
              </td>

              {/* Team 1 (read-only) */}
              <td>{game.team1?.name || "N/A"}</td>

              {/* Team 2 (read-only) */}
              <td>{game.team2?.name || "N/A"}</td>

              {/* Score T1 */}
              <td>
                <input
                  type="number"
                  value={editData[game._id]?.scoreTeam1 ?? game.scoreTeam1 ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) => handleFieldChange(editData,setEditData,game._id, "scoreTeam1", e.target.value)}
                />
              </td>

              {/* Score T2 */}
              <td>
                <input
                  type="number"
                  value={editData[game._id]?.scoreTeam2 ?? game.scoreTeam2 ?? ""}
                  disabled={!selectedGames.includes(game._id)}
                  onChange={(e) => handleFieldChange(editData,setEditData,game._id, "scoreTeam2", e.target.value)}
                />
              </td>

              {/* Division (read-only) */}
              <td>{game.division?.name || "N/A"}</td>

              {/* Court (read-only) */}
              <td>{game.court || ""}</td>

              {/* Date (read-only) */}
              <td>{game.date || ""}</td>

              {/* Time (read-only) */}
              <td>{game.time || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: "15px" }}>
        <button onClick={handleSaveScores} disabled={!selectedGames.length}>
          Save Scores
        </button>
      </div>
       <br/>
          <br/>
         <div>
          <button onClick={CalcuateStanding}>Calculate Standing</button>
          <p>Feel Free to calculate as many time as you save socre. It recalculates all numbers each time. 
            <br />Please note: Teams are ranked by wins, 
            then point difference (points scored minus opponent’s points),
             then total points scored. </p>
        </div>
    </div>
  );
};

export default AddScore;
